/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'
import { useAuth } from '../../../../app/modules/auth'
import { ClaimModel, PublishingOptionModel } from '../../../../app/modules/auth/core/_models'
import { getFileAreas } from '../../../../app/modules/filearea/fileareas-list/core/_requests'
import { FileArea, initialFileAreas } from '../../../../app/modules/filearea/fileareas-list/core/_models'
import { getCourseTypes } from '../../../../app/modules/coursetype/coursetypes-list/core/_requests'
import { CourseType, initialCourseTypes } from '../../../../app/modules/coursetype/coursetypes-list/core/_models'
import { getPublishingOptions } from '../../../../app/modules/publishingoption/publishingoptions-list/core/_requests'
import { PublishingOption, initialPublishingOptions } from '../../../../app/modules/publishingoption/publishingoptions-list/core/_models'
import { RoleModel } from '../../../../app/modules/auth/core/_models'

export function AsideMenuMain() {
  const intl = useIntl()
  const { currentUser, auth } = useAuth()
  const [fileAreas, setFileAreas] = useState<FileArea[]>(initialFileAreas)
  const [courseTypes, setCourseTypes] = useState<CourseType[]>(initialCourseTypes)
  const [publishinOptions, setPublishingOptions] = useState<PublishingOption[]>(initialPublishingOptions)

  useEffect(() => {
    getFileAreas('').then((values) => { setFileAreas(values.data!) })
    getCourseTypes('').then((values) => { setCourseTypes(values.data!) })
    getPublishingOptions('').then((values) => { setPublishingOptions(values.data!) })
  }, [])

  return (
    <>
      {(currentUser?.menus?.includes(ClaimModel.dashboard)) &&
        <>
          <AsideMenuItem
            to='/dashboard'
            title={intl.formatMessage({ id: 'dts' })}
            icon='/media/icons/duotune/art/dashboard1.svg'
            fontIcon='bi-app-indicator'
          />
        </>
      }



      {(currentUser?.menus?.includes(ClaimModel.chat)) &&
        <>
          <AsideMenuItem
            to='/apps/chat/private-chat'
            title={intl.formatMessage({ id: 'a38' })}
            fontIcon='bi-chat-left'
            icon='/media/icons/duotune/communication/message1.svg' />
        </>
      }


      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>{intl.formatMessage({ id: 'usw' })}</span>
        </div>
      </div>

      {(currentUser?.menus?.includes(ClaimModel.institution) ||
        currentUser?.menus?.includes(ClaimModel.persontype) ||
        currentUser?.menus?.includes(ClaimModel.gender)) &&
        <AsideMenuItemWithSub
          to='/crafted/institutions'
          title={intl.formatMessage({ id: 'qov' })}
          icon='/media/icons/duotune/communication/institution.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.institution) && <AsideMenuItem to='/crafted/institutions/institution/institution' title={intl.formatMessage({ id: 'qov' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.persontype) && <AsideMenuItem to='/crafted/institutions/persontype/persontype' title={intl.formatMessage({ id: 'nis' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.gender) && <AsideMenuItem to='/crafted/institutions/gender/gender' title={intl.formatMessage({ id: 'ibl' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.subinstitution) ||
        currentUser?.menus?.includes(ClaimModel.subinstitutiontype) ||
        currentUser?.menus?.includes(ClaimModel.class) ||
        currentUser?.menus?.includes(ClaimModel.subinstitutiontypebranch) ||
        currentUser?.menus?.includes(ClaimModel.academicyear) ||
        currentUser?.menus?.includes(ClaimModel.term) ||
        currentUser?.menus?.includes(ClaimModel.place) ||
        currentUser?.menus?.includes(ClaimModel.lesson) ||
        currentUser?.menus?.includes(ClaimModel.subject) ||
        currentUser?.menus?.includes(ClaimModel.subinstitutionlesson)) &&
        <AsideMenuItemWithSub
          to='/crafted/subinstitutions'
          title={intl.formatMessage({ id: 'wqr' })}
          icon='/media/icons/duotune/communication/school1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.subinstitution) && <AsideMenuItem to='/crafted/subinstitutions/subinstitution/subinstitution' title={intl.formatMessage({ id: 'wqr' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.subinstitutiontype) && <AsideMenuItem to='/crafted/subinstitutions/subinstitutiontype/subinstitutiontype' title={intl.formatMessage({ id: 'l0p' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.class) && <AsideMenuItem to='/crafted/subinstitutions/class/class' title={intl.formatMessage({ id: 'c76' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.subinstitutiontypebranch) && <AsideMenuItem to='/crafted/subinstitutions/subinstitutiontypebranch/subinstitutiontypebranch' title={intl.formatMessage({ id: '6rk' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.academicyear) && <AsideMenuItem to='/crafted/subinstitutions/academicyear/academicyear' title={intl.formatMessage({ id: '7ir' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.term) && <AsideMenuItem to='/crafted/subinstitutions/term/term' title={intl.formatMessage({ id: 'ahe' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.place) && <AsideMenuItem to='/crafted/subinstitutions/place/place' title={intl.formatMessage({ id: 'fp0' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.lesson) && <AsideMenuItem to='/crafted/subinstitutions/lesson/lesson' title={intl.formatMessage({ id: 'dm0' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.subject) && <AsideMenuItem to='/crafted/subinstitutions/subject/subject' title={intl.formatMessage({ id: 'qer' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.subinstitutionlesson) && <AsideMenuItem to='/crafted/curricula/subinstitutionlesson/subinstitutionlesson' title={intl.formatMessage({ id: 'ryp' })} hasBullet={true} />}
          </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.user) ||
        currentUser?.menus?.includes(ClaimModel.role) ||
        currentUser?.menus?.includes(ClaimModel.roleclaim) ||
        currentUser?.menus?.includes(ClaimModel.userclaim) ||
        currentUser?.menus?.includes(ClaimModel.userlogin) ||
        currentUser?.menus?.includes(ClaimModel.userrole)) &&
        <AsideMenuItemWithSub
          to='/crafted/users'
          title={intl.formatMessage({ id: 'x34' })}
          icon='/media/icons/duotune/communication/user1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.user) && <AsideMenuItem to='/crafted/users/user/user' title={intl.formatMessage({ id: 'kex' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.role) && <AsideMenuItem to='/crafted/users/role/role' title={intl.formatMessage({ id: 'klh' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.roleclaim) && <AsideMenuItem to='/crafted/users/roleclaim/roleclaim' title={intl.formatMessage({ id: '0hc' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.userclaim) && <AsideMenuItem to='/crafted/users/userclaim/userclaim' title={intl.formatMessage({ id: 'f6a' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.userlogin) && <AsideMenuItem to='/crafted/users/userlogin/userlogin' title={intl.formatMessage({ id: 'ods' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.userrole) && <AsideMenuItem to='/crafted/users/userrole/userrole' title={intl.formatMessage({ id: 'hxa' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.file) ||
        currentUser?.menus?.includes(ClaimModel.filearea) ||
        currentUser?.menus?.includes(ClaimModel.filetype) ||
        currentUser?.menus?.includes(ClaimModel.fileshare)) &&
        <AsideMenuItemWithSub
          to='/crafted/accounts'
          title={intl.formatMessage({ id: 'd1b' })}
          icon='/media/icons/duotune/communication/account1.svg'
          fontIcon='bi-person'
        >
          <AsideMenuItem to='/crafted/accounts/profile/overview' title={intl.formatMessage({ id: 'dud' })} hasBullet={true} />
          {auth?.currentRole === RoleModel.Admin && currentUser?.menus?.includes(ClaimModel.file) && <AsideMenuItem to='/crafted/accounts/file/file' title={intl.formatMessage({ id: '5qi' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.filearea) && <AsideMenuItem to='/crafted/accounts/filearea/filearea' title={intl.formatMessage({ id: 'k9e' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.filetype) && <AsideMenuItem to='/crafted/accounts/filetype/filetype' title={intl.formatMessage({ id: 'hzh' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.fileshare) && <AsideMenuItem to='/crafted/accounts/fileshare/fileshare' title={intl.formatMessage({ id: '4th' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.study) ||
        currentUser?.menus?.includes(ClaimModel.customerstudy) ||
        currentUser?.menus?.includes(ClaimModel.reportstudy) ||
        currentUser?.menus?.includes(ClaimModel.dashboardstudy) ||
        currentUser?.menus?.includes(ClaimModel.studytype) ||
        currentUser?.menus?.includes(ClaimModel.studyeventtype) ||
        currentUser?.menus?.includes(ClaimModel.prioritycoloringtype) ) &&
        <AsideMenuItemWithSub
          to='/crafted/studies'
          title={intl.formatMessage({ id: '2uv' })}
          icon='/media/icons/duotune/communication/study1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardstudy) && <AsideMenuItem to='/crafted/studies/dashboardstudy/dashboardstudy' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.study) && <AsideMenuItem to='/crafted/studies/study/study' title={intl.formatMessage({ id: '2uv' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customerstudy) && <AsideMenuItem to='/crafted/studies/customerstudy/customerstudy' title={intl.formatMessage({ id: '2uv' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.reportstudy) && <AsideMenuItem to='/crafted/studies/reportstudy/reportstudy' title={intl.formatMessage({ id: 'jfp' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.studytype) && <AsideMenuItem to='/crafted/studies/studytype/studytype' title={intl.formatMessage({ id: '14z' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.studyeventtype) && <AsideMenuItem to='/crafted/studies/studyeventtype/studyeventtype' title={intl.formatMessage({ id: 'gtw' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.prioritycoloringtype) && <AsideMenuItem to='/crafted/studies/prioritycoloringtype/prioritycoloringtype' title={intl.formatMessage({id:"6af"})} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.employee) ||
        currentUser?.menus?.includes(ClaimModel.employeetype) ||
        currentUser?.menus?.includes(ClaimModel.dashboardemployee) ||
        currentUser?.menus?.includes(ClaimModel.workingstatue) ||
        currentUser?.menus?.includes(ClaimModel.unit) ||
        currentUser?.menus?.includes(ClaimModel.unittype)) &&
        <AsideMenuItemWithSub
          to='/crafted/employees'
          title={intl.formatMessage({ id: '4ny' })}
          icon='/media/icons/duotune/communication/employee1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardemployee) && <AsideMenuItem to='/crafted/employees/dashboardemployee/dashboardemployee' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.employee) && <AsideMenuItem to='/crafted/employees/employee/employee' title={intl.formatMessage({ id: '4ny' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.employeetype) && <AsideMenuItem to='/crafted/employees/employeetype/employeetype' title={intl.formatMessage({ id: 'uq5' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.workingstatue) && <AsideMenuItem to='/crafted/employees/workingstatue/workingstatue' title={intl.formatMessage({ id: '11u' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.unit) && <AsideMenuItem to='/crafted/employees/unit/unit' title={intl.formatMessage({ id: '5sh' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.unittype) && <AsideMenuItem to='/crafted/employees/unittype/unittype' title={intl.formatMessage({ id: 'gsb' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.customer) ||
        currentUser?.menus?.includes(ClaimModel.dashboardcustomer) ||
        currentUser?.menus?.includes(ClaimModel.customerinfo) ||
        currentUser?.menus?.includes(ClaimModel.person)) &&
        <AsideMenuItemWithSub
          to='/crafted/customers'
          title={intl.formatMessage({ id: 'vxt' })}
          icon='/media/icons/duotune/communication/customer1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardcustomer) && <AsideMenuItem to='/crafted/customers/dashboardcustomer/dashboardcustomer' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customerinfo) && <AsideMenuItem to='/crafted/customers/customerinfo/customerinfo' title={intl.formatMessage({ id: 's4l' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customer) && <AsideMenuItem to='/crafted/customers/customer/customer' title={intl.formatMessage({ id: 'vxt' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.person) && <AsideMenuItem to='/crafted/customers/person/person' title={intl.formatMessage({ id: 'pb0' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.course) ||
        currentUser?.menus?.includes(ClaimModel.coursetype) ||
        currentUser?.menus?.includes(ClaimModel.courselevel) ||
        currentUser?.menus?.includes(ClaimModel.courseskill) ||
        currentUser?.menus?.includes(ClaimModel.courseresulttype) ||
        currentUser?.menus?.includes(ClaimModel.courseresult) ||
        currentUser?.menus?.includes(ClaimModel.proficiencytest) ||
        currentUser?.menus?.includes(ClaimModel.publishingoption) ||
        currentUser?.menus?.includes(ClaimModel.courseschedule) ||
        currentUser?.menus?.includes(ClaimModel.guidancetype) ||
        currentUser?.menus?.includes(ClaimModel.guidancesubtype) ||
        currentUser?.menus?.includes(ClaimModel.dashboardguidance) ||
        currentUser?.menus?.includes(ClaimModel.guidanceresulttype) ||
        currentUser?.menus?.includes(ClaimModel.guidanceinfo)) &&
        <AsideMenuItemWithSub
          to='/crafted/courses'
          title={intl.formatMessage({ id: 'o9a' })}
          fontIcon='bi-chat-left'
          icon='/media/icons/duotune/communication/chat1.svg'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardguidance) && <AsideMenuItem to='/crafted/guidances/dashboardguidance/dashboardguidance' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.course) && <AsideMenuItem to='/crafted/courses/course/course' title={intl.formatMessage({ id: 'o8a' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.courseresult) && <AsideMenuItem to='/crafted/courses/courseresult/courseresult' title={intl.formatMessage({ id: 'o8g' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.guidanceinfo) && <AsideMenuItem to='/crafted/guidances/guidanceinfo/guidanceinfo' title={intl.formatMessage({ id: '6ea' })} hasBullet={true} />}
          
          {currentUser?.menus?.includes(ClaimModel.coursetype) && <AsideMenuItem to='/crafted/courses/coursetype/coursetype' title={intl.formatMessage({ id: 'o8b' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.courselevel) && <AsideMenuItem to='/crafted/courses/courselevel/courselevel' title={intl.formatMessage({ id: 'o8c' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.courseskill) && <AsideMenuItem to='/crafted/courses/courseskill/courseskill' title={intl.formatMessage({ id: 'o8h' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.courseresulttype) && <AsideMenuItem to='/crafted/courses/courseresulttype/courseresulttype' title={intl.formatMessage({ id: 'o8i' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.proficiencytest) && <AsideMenuItem to='/crafted/courses/proficiencytest/proficiencytest' title={intl.formatMessage({ id: 'o8d' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.courseschedule) && <AsideMenuItem to='/crafted/courses/courseschedule/courseschedule' title={intl.formatMessage({ id: 'o9p' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.publishingoption) && <AsideMenuItem to='/crafted/courses/publishingoption/publishingoption' title={intl.formatMessage({ id: 'o8u' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.guidancetype) && <AsideMenuItem to='/crafted/guidances/guidancetype/guidancetype' title={intl.formatMessage({ id: 'k9a' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.guidancesubtype) && <AsideMenuItem to='/crafted/guidances/guidancesubtype/guidancesubtype' title={intl.formatMessage({ id: 'k9b' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.guidanceresulttype) && <AsideMenuItem to='/crafted/guidances/guidanceresulttype/guidanceresulttype' title={intl.formatMessage({ id: 'k9d' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customerguidance) && <AsideMenuItem to='/crafted/guidances/customerguidance/customerguidance' title={intl.formatMessage({ id: 'sj0' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }



      {
      (currentUser?.menus?.includes(ClaimModel.guidance)) &&
        courseTypes &&
        courseTypes.map((courseType, index) =>
          <AsideMenuItemWithSub
            to={'/crafted/guidances' + courseType.id}
            title={String(courseType.name)}
            icon='/media/icons/duotune/communication/chat1.svg'
            fontIcon='bi-person'
          >

            {publishinOptions &&
              publishinOptions.map((publishingOption, indexPublishingOption) =>
                ((auth!.currentRole === RoleModel.GuidanceManager) ||
                  (auth!.currentRole === RoleModel.SchoolManager) ||
                  (auth!.currentRole === RoleModel.InstitutionManager) ||
                  (auth!.currentRole === RoleModel.Customer && (publishingOption!.id! === PublishingOptionModel.Evaluation)) ||
                  (auth!.currentRole === RoleModel.Teacher && (publishingOption!.id! === PublishingOptionModel.Observation || publishingOption!.id! === PublishingOptionModel.Conversation)) ||
                  (auth!.currentRole === RoleModel.Person && (publishingOption!.id! === PublishingOptionModel.Evaluation || publishingOption!.id! === PublishingOptionModel.Observation))) &&
                (publishingOption && <AsideMenuItem to={'/crafted/guidances' + index + '/guidance/guidance' + publishingOption.id + '?publishingoptionid=' + publishingOption.id + '&coursetypeid=' + courseType.id} title={publishingOption.name!} hasBullet={true} />)
              )}
          </AsideMenuItemWithSub>
        )
      }


      {(currentUser?.menus?.includes(ClaimModel.file)) &&
        <AsideMenuItemWithSub
          to='/crafted/files'
          title={intl.formatMessage({ id: 'k9f' })}
          icon='/media/icons/duotune/communication/study2.svg'
          fontIcon='bi-person'
        >
          {fileAreas &&
            fileAreas.map((fileArea) =>
              <AsideMenuItem to={'/crafted/files/file/file' + fileArea.id + '?fileareaid=' + fileArea.id} title={fileArea.name!} hasBullet={true} />
            )}

        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.curriculum) ||
        currentUser?.menus?.includes(ClaimModel.curriculumtype) ||
        currentUser?.menus?.includes(ClaimModel.activity) ||
        currentUser?.menus?.includes(ClaimModel.dashboardcurriculum)) &&
        <AsideMenuItemWithSub
          to='/crafted/curricula'
          title={intl.formatMessage({ id: '8pe' })}
          icon='/media/icons/duotune/communication/curriculum1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardcurriculum) && <AsideMenuItem to='/crafted/curricula/dashboardcurriculum/dashboardcurriculum' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.curriculum) && <AsideMenuItem to='/crafted/curricula/curriculum/curriculum' title={intl.formatMessage({ id: '8pe' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.curriculumtype) && <AsideMenuItem to='/crafted/curricula/curriculumtype/curriculumtype' title={intl.formatMessage({ id: 'oe6' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.activity) && <AsideMenuItem to='/crafted/curricula/activity/activity' title={intl.formatMessage({ id: '6lb' })} hasBullet={true} />}

        </AsideMenuItemWithSub>
      }


      {(currentUser?.menus?.includes(ClaimModel.survey) ||
        currentUser?.menus?.includes(ClaimModel.customersurvey) ||
        currentUser?.menus?.includes(ClaimModel.reportsurvey) ||
        currentUser?.menus?.includes(ClaimModel.dashboardsurvey) ||
        currentUser?.menus?.includes(ClaimModel.surveyquestion) ||
        currentUser?.menus?.includes(ClaimModel.surveyresult) ||
        currentUser?.menus?.includes(ClaimModel.surveytype)) &&
        <AsideMenuItemWithSub
          to='/crafted/surveys'
          title={intl.formatMessage({ id: '5od' })}
          icon='/media/icons/duotune/communication/survey1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardsurvey) && <AsideMenuItem to='/crafted/surveys/dashboardsurvey/dashboardsurvey' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.survey) && <AsideMenuItem to='/crafted/surveys/survey/survey' title={intl.formatMessage({ id: '5od' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customersurvey) && <AsideMenuItem to='/crafted/surveys/customersurvey/customersurvey' title={intl.formatMessage({ id: '5od' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.reportsurvey) && <AsideMenuItem to='/crafted/surveys/reportsurvey/reportsurvey' title={intl.formatMessage({ id: 'jfp' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.surveyquestion) && <AsideMenuItem to='/crafted/surveys/surveyquestion/surveyquestion' title={intl.formatMessage({ id: 'fg0' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.surveyresult) && <AsideMenuItem to='/crafted/surveys/surveyresult/surveyresult' title={intl.formatMessage({ id: '2ml' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.surveytype) && <AsideMenuItem to='/crafted/surveys/surveytype/surveytype' title={intl.formatMessage({ id: 'ug7' })} hasBullet={true} />}


        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.announcement) ||
        currentUser?.menus?.includes(ClaimModel.customerannouncement) ||
        currentUser?.menus?.includes(ClaimModel.dashboardannouncement)) &&
        <AsideMenuItemWithSub
          to='/crafted/announcements'
          title={intl.formatMessage({ id: 'ow5' })}
          icon='/media/icons/duotune/communication/announcement1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.dashboardannouncement) && <AsideMenuItem to='/crafted/announcements/dashboardannouncement/dashboardannouncement' title={intl.formatMessage({ id: 'dtq' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.announcement) && <AsideMenuItem to='/crafted/announcements/announcement/announcement' title={intl.formatMessage({ id: 'ow5' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customerannouncement) && <AsideMenuItem to='/crafted/announcements/customerannouncement/customerannouncement' title={intl.formatMessage({ id: 'ow5' })} hasBullet={true} />}

        </AsideMenuItemWithSub>
      }


      {(currentUser?.menus?.includes(ClaimModel.message) ||
        currentUser?.menus?.includes(ClaimModel.customermessage) ||
        currentUser?.menus?.includes(ClaimModel.reportmessage) ||
        currentUser?.menus?.includes(ClaimModel.messagetype)) &&
        <AsideMenuItemWithSub
          to='/crafted/messages'
          title={intl.formatMessage({ id: 'whs' })}
          icon='/media/icons/duotune/communication/message2.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.message) && <AsideMenuItem to='/crafted/messages/message/message' title={intl.formatMessage({ id: 'whs' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.customermessage) && <AsideMenuItem to='/crafted/messages/customermessage/customermessage' title={intl.formatMessage({ id: 'whs' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.reportmessage) && <AsideMenuItem to='/crafted/messages/reportmessage/reportmessage' title={intl.formatMessage({ id: 'jfp' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.messagetype) && <AsideMenuItem to='/crafted/messages/messagetype/messagetype' title={intl.formatMessage({ id: 'k97' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }


      {(currentUser?.menus?.includes(ClaimModel.ticket) ||
        currentUser?.menus?.includes(ClaimModel.ticketstatu) ||
        currentUser?.menus?.includes(ClaimModel.tickettype)) &&
        <AsideMenuItemWithSub
          to='/crafted/tickets'
          title={intl.formatMessage({ id: 'akg' })}
          icon='/media/icons/duotune/communication/ticket1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.ticket) && <AsideMenuItem to='/crafted/tickets/ticket/ticket' title={intl.formatMessage({ id: 'akg' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.ticketstatu) && <AsideMenuItem to='/crafted/tickets/ticketstatu/ticketstatu' title={intl.formatMessage({ id: '747' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.tickettype) && <AsideMenuItem to='/crafted/tickets/tickettype/tickettype' title={intl.formatMessage({ id: '285' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.help)) &&
        <AsideMenuItemWithSub
          to='/crafted/helps'
          title={intl.formatMessage({ id: 'r5d' })}
          icon='/media/icons/duotune/communication/help.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.help) && <AsideMenuItem to='/crafted/helps/help/help' title={intl.formatMessage({ id: 'r5d' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.currency) ||
        currentUser?.menus?.includes(ClaimModel.pricing) ||
        currentUser?.menus?.includes(ClaimModel.offer) ||
        currentUser?.menus?.includes(ClaimModel.offerstatus) ||
        currentUser?.menus?.includes(ClaimModel.offertype) ||
        currentUser?.menus?.includes(ClaimModel.sale) ||
        currentUser?.menus?.includes(ClaimModel.seller)) &&
        <AsideMenuItemWithSub
          to='/crafted/sales'
          title={intl.formatMessage({ id: 'de7' })}
          icon='/media/icons/duotune/communication/sales.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.sale) && <AsideMenuItem to='/crafted/sales/sale/sale' title={intl.formatMessage({ id: 'de7' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.offer) && <AsideMenuItem to='/crafted/sales/offer/offer' title={intl.formatMessage({ id: 'yzg' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.offertype) && <AsideMenuItem to='/crafted/sales/offertype/offertype' title={intl.formatMessage({ id: 'kcj' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.offerstatus) && <AsideMenuItem to='/crafted/sales/offerstatus/offerstatus' title={intl.formatMessage({ id: 'dd9' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.seller) && <AsideMenuItem to='/crafted/sales/seller/seller' title={intl.formatMessage({ id: '567' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.pricing) && <AsideMenuItem to='/crafted/sales/pricing/pricing' title={intl.formatMessage({ id: '3tc' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.currency) && <AsideMenuItem to='/crafted/sales/currency/currency' title={intl.formatMessage({ id: 'e2s' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.country) ||
        currentUser?.menus?.includes(ClaimModel.city) ||
        currentUser?.menus?.includes(ClaimModel.language)) &&
        <AsideMenuItemWithSub
          to='/crafted/countries'
          title={intl.formatMessage({ id: 'o9q' })}
          icon='/media/icons/duotune/communication/country.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.country) && <AsideMenuItem to='/crafted/countries/country/country' title={intl.formatMessage({ id: 'o9q' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.city) && <AsideMenuItem to='/crafted/countries/city/city' title={intl.formatMessage({ id: 're9' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.language) && <AsideMenuItem to='/crafted/countries/language/language' title={intl.formatMessage({ id: '2qg' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.claimvalue) ||
        currentUser?.menus?.includes(ClaimModel.moduleinstitution) ||
        currentUser?.menus?.includes(ClaimModel.page) ||
        currentUser?.menus?.includes(ClaimModel.module)) &&
        <AsideMenuItemWithSub
          to='/crafted/modules'
          title={intl.formatMessage({ id: 'Modül' })}
          icon='/media/icons/duotune/communication/user1.svg'
          fontIcon='bi-person'
        >
          {currentUser?.menus?.includes(ClaimModel.claimvalue) && <AsideMenuItem to='/crafted/modules/claimvalue/claimvalue' title={intl.formatMessage({ id: 'Yetkiler' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.moduleinstitution) && <AsideMenuItem to='/crafted/modules/moduleinstitution/moduleinstitution' title={intl.formatMessage({ id: 'Kurum Modülleri' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.page) && <AsideMenuItem to='/crafted/modules/page/page' title={intl.formatMessage({ id: 'Sayfalar' })} hasBullet={true} />}
          {currentUser?.menus?.includes(ClaimModel.module) && <AsideMenuItem to='/crafted/modules/module/module' title={intl.formatMessage({ id: 'Modüller' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }

      {(currentUser?.menus?.includes(ClaimModel.gallery)) &&
        <AsideMenuItemWithSub
          to='/crafted/galleries'
          title={intl.formatMessage({ id: 'mme' })}
          icon='/media/icons/duotune/communication/gallery.svg'
          fontIcon='bi-person'
        >

          {currentUser?.menus?.includes(ClaimModel.gallery) && <AsideMenuItem to='/crafted/galleries/gallery/gallery' title={intl.formatMessage({ id: 'mme' })} hasBullet={true} />}
        </AsideMenuItemWithSub>
      }
    </>
  )
}
